import { createHook, createStore, StoreActionApi } from "react-sweet-state"
import { load, LoadingState, LoadingStateDefaults } from "components/state/loader"
import { Container } from "components/state/types"
import { query } from "./endpoint"


interface User {
    email: string;
}

interface Member {
    id: number; // idt
    userIdMember: boolean;
    userMemberIdt?: number;
    hasAccess: boolean;
    divisionId: number;
    clubId?: number;
}

const MemberDefaults: Member = {
    id: 0,
    userIdMember: false,
    userMemberIdt: null,
    hasAccess: false,
    divisionId: 0,
    clubId: null
};

interface Email {
    email: string;
    isKnownEmail: boolean;
    isLoggedWithThisEmail: boolean;
}

const EmailDefaults: Email = {
    email: "",
    isKnownEmail: false,
    isLoggedWithThisEmail: false,
}


// Request entities
interface UIContextQuery {
    data: {
        member?: Partial<Member>;
        is_known_email?: Partial<Email>;
    }
}

const createEmptyContextQuery = (): UIContextQuery => {
    return {
        data: {}
    }
}

const createMemberContextQuery = (idt: number): UIContextQuery => {
    return {
        data: {
            member: {
                id: idt
            }
        }
    }
}

const createIsKnownEmailContextQuery = (email: string): UIContextQuery => {
    return {
        data: {
            is_known_email: {
                email
            }
        }
    }
}

// Response entities
interface UIContext {
    data: {
        logged_user?: User;
        member?: Member;
        is_known_email?: Email;
    };
}


// State
interface State extends LoadingState, UIContext {
    memberLoaded: boolean;
}

const StateDefaults: State = {
    ...LoadingStateDefaults,
    data: {
        logged_user: null,
        member: MemberDefaults,
        is_known_email: EmailDefaults,
    },
    memberLoaded: false,
}

// Actions
const initialize = () =>
    (store: StoreActionApi<State>) => {
        let loader =
            () => query(createEmptyContextQuery());

        let stateProducer =
            (draft: State, response: Container): void => {
                draft.data.logged_user = response?.data?.logged_user;
            }

        load<State>(store, loader, stateProducer);
    };

const loadMember = (idt: number) =>
    (store: StoreActionApi<State>) => {

        store.setState(draft => {
            draft.memberLoaded = false;
        });

        let loader = () => query(createMemberContextQuery(idt));

        let stateProducer = (draft: State, response: Container): void => {
            draft.data.logged_user = response?.data?.logged_user;
            draft.data.member = response?.data?.member;
            draft.memberLoaded = true;
        }

        load<State>(store, loader, stateProducer);
    };

const loadKnownEmail = (email: string) =>
    (store: StoreActionApi<State>) => {
        let loader =
            () => query(createIsKnownEmailContextQuery(email));

        let stateProducer =
            (draft: State, response: Container): void => {
                draft.data.logged_user = response?.data?.logged_user;
                draft.data.is_known_email = response?.data?.is_known_email;
            }

        load<State>(store, loader, stateProducer);
    };

const store = createStore({
    initialState: StateDefaults,
    actions: {
        initialize,
        loadMember,
        loadKnownEmail
    },
    name: "UIContext"
});

const useState = createHook(store);

export {
    StateDefaults as UIContextDefaults,
    State as UIContext,
    UIContextQuery,
    useState as useUIContext,
}